<!-- HEADER COMPONENT -->
<app-header />
<!-- ---------------- -->

<div class="min-h-[90vh] mt-14">
    <!-- PAGE BODY -->
    <router-outlet />
    <!-- --------- -->
</div>

<!-- FOOTER COMPONENT -->
<app-footer />
<!-- ---------------- -->
